import { render, staticRenderFns } from "./MediaProperty.vue?vue&type=template&id=1ff4703c&"
import script from "./MediaProperty.vue?vue&type=script&lang=js&"
export * from "./MediaProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports